const mockUsers = [
  {
    id: 1,
    name: "관리자",
    email: "edi@ulogitech.com",
    role: "admin",
    status: "active",
    createdAt: "2024-01-15",
  }
];

import { logger } from "@/lib/logger";

let users = [...mockUsers];

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const userApi = {
  getUsers: async () => {
    logger.debug("API: Getting users");
    logger.time("getUsers");
    await delay(500);
    logger.timeEnd("getUsers");
    logger.debug("API: Users fetched", users.length, "users");
    return users;
  },

  getUserById: async (id) => {
    await delay(300);
    const user = users.find((u) => u.id === parseInt(id));
    if (!user) {
      throw new Error("User not found");
    }
    return user;
  },

  createUser: async (userData) => {
    logger.debug("API: Creating user", userData);
    await delay(800);
    const newUser = {
      ...userData,
      id: Math.max(...users.map((u) => u.id)) + 1,
      createdAt: new Date().toISOString().split("T")[0],
      status: "active",
    };
    users = [...users, newUser];
    logger.info("API: User created", newUser);
    return newUser;
  },

  updateUser: async (id, userData) => {
    await delay(800);
    const index = users.findIndex((u) => u.id === parseInt(id));
    if (index === -1) {
      throw new Error("User not found");
    }
    users[index] = { ...users[index], ...userData };
    return users[index];
  },

  deleteUser: async (id) => {
    await delay(500);
    const index = users.findIndex((u) => u.id === parseInt(id));
    if (index === -1) {
      throw new Error("User not found");
    }
    users = users.filter((u) => u.id !== parseInt(id));
    return { success: true };
  },

  // 대량 업데이트
  bulkUpdateUsers: async (updates) => {
    await delay(1000);
    updates.forEach((update) => {
      const index = users.findIndex((u) => u.id === update.id);
      if (index !== -1) {
        users[index] = { ...users[index], ...update.data };
      }
    });
    return { success: true };
  },
};
